import { ViewRegistry, ModelRegistry, Repeat, Show } from '@lernetz/ts-lib';
import {RouterView} from '@lernetz/ui-components/src/router/Router';
import {StackView} from '@lernetz/ui-components/src/stack/Stack';
import {Heading, HeadingView} from '@lernetz/ui-components/src/heading/Heading';
import {Html, HtmlView } from '@lernetz/ui-components/src/html/Html';
import {SvgIconView} from "@lernetz/ui-components/src/svg-icons/SvgIcon";

import { AppView } from './components/app/App';
import {Paragraph, ParagraphView} from './components/article-elements/paragraph/Paragraph';
import {Title, TitleView} from './components/article-elements/title/Title';
import {NavigationView} from './components/navigation/Navigation';
import {Topics} from './components/topics/Topics';
import {WizardView} from './components/wizard/Wizard';
import {GoodPracticeView} from './pages/good-practice/good-practice.view';
import {HomeView} from './pages/Home';
import {ToolDetailsView} from './pages/tools/details/tool-details.view';
import {ToolsPageView} from './pages/tools/tools.view';
import {router} from './services/router';
import {ToolListView} from './tool/components/list/list.view';
import StackTemplate from './pages/Stack.html';
import {SearchPage} from './pages/search/search';
import {SearchRow} from './components/search-row/search-row.component';
import {SliderView} from './components/common/slider/slider.component';
import {FooterView} from './components/footer/footer.component';
import {FilterView} from './components/filter/filter.component';
import { DropDownView } from '@lernetz/ui-components/src/drop-down/DropDown';
import dropDownTemplate from './components/common/dropdown/DropDown.component.html';
import symbols from './icons/symbols.html';
import {Image, ImageView} from './components/article-elements/image/Image';
import { DecoratedIframely, DecoratedIframelyView } from './components/article-elements/decoratedIframely/DecoratedIframely';
import { ImageView as BaseImageView } from '@lernetz/ui-components/src/image/Image';
import {BannerImage} from './components/common/banner-image/banner-image.component';
import {MetaInfos} from './pages/tools/details/metainfos.component';
import {DropDownController} from './components/common/dropdown/dropdown.component';
import {GoodPracticeDetails} from './pages/good-practice/details/good-practice-details.component';
import {Toggle, ToggleView} from './components/article-elements/toggle/Toggle';
import {PersonalImpact, PersonalImpactView} from './components/article-elements/personal-impact/PersonalImpact';
import {Carousel, CarouselView} from './components/article-elements/carousel/Carousel';
import {GenericPage} from './pages/generic/generic.component';
import {MaterialList, MaterialListView} from './components/article-elements/materiallist/MaterialList';
import {CheckboxToggle} from './components/common/checkbox/checkbox.component';
import {MissingPageView} from './pages/Missing';
import {Overlay} from './components/common/overlay/overlay.component';
import {WizardStart} from './components/wizard/WizardStart';
import {ResultPage} from './pages/results/results.component';
import {ActiveTags} from './components/tags/active-tags.component';
import {RelatedContent, RelatedContentView} from './components/article-elements/related-content/related-content.component';
import {RouteLink} from './components/common/route-link/route-link.component';
import {ModalView} from './components/modal/modal.component';
import { Podcast, PodcastView } from './components/article-elements/podcast/Podcast';
import { SvelteView } from "@lernetz/svelte-compatibility";
import Filter from "./components/filter/Filter.svelte";
import { RawHtml, RawHtmlView } from "./components/article-elements/rawhtml/RawHtml";


export const viewRegistry = new ViewRegistry();
viewRegistry.add( 'App', () => new AppView() );
viewRegistry.add( 'Router', () => new RouterView( { data: router } ) );
viewRegistry.add( 'RouteLink', () => new RouteLink(router) );
viewRegistry.add( 'Stack', () => new StackView({ template: StackTemplate }) );

// Pages
viewRegistry.add( 'Missing', () => new MissingPageView() );
viewRegistry.add( 'Home', () => new HomeView() );

viewRegistry.add( 'Wizard', () => new WizardView() );
viewRegistry.add( 'WizardStart', () => new WizardStart() );

viewRegistry.add( 'GoodPracticePage', () => new GoodPracticeView() );
viewRegistry.add( 'GoodPracticeDetailsPage', () => new GoodPracticeDetails() );
viewRegistry.add( 'ToolsPage', () => new ToolsPageView() );
viewRegistry.add( 'ToolDetailsPage', () => new ToolDetailsView() );
viewRegistry.add( 'SearchPage', () => new SearchPage() );
viewRegistry.add( 'GenericPage', () => new GenericPage() );
viewRegistry.add( 'ResultPage', () => new ResultPage() );

viewRegistry.add( 'Navigation', () => new NavigationView() );
viewRegistry.add( 'Footer', () => new FooterView() );
viewRegistry.add( 'Topics', () => new Topics() );
viewRegistry.add( 'SearchRow', () => new SearchRow() );
viewRegistry.add( 'CardList', () => new ToolListView() );
viewRegistry.add('Filter', () => new SvelteView(Filter));
//viewRegistry.add('Filter', () => new FilterView());
viewRegistry.add('ActiveTags', () => new ActiveTags());

viewRegistry.add( 'Show', () => new Show() );
viewRegistry.add( 'Repeat', () => new Repeat() );
viewRegistry.add( 'DropDown', () => new DropDownView({ template: dropDownTemplate, data: new DropDownController() as any}) );
viewRegistry.add('Icon', () => new SvgIconView({ symbols }) );
viewRegistry.add('Checkbox', () => new CheckboxToggle());
viewRegistry.add('Overlay', () => new Overlay());

viewRegistry.add('MetaInfos', () => new MetaInfos());

viewRegistry.add( 'Slider', () => new SliderView());

// article
viewRegistry.add( Title, () => new TitleView() );
viewRegistry.add( 'Heading', () => new HeadingView( { data: new Heading({
    styles: {
        'h1': 'tt-h1 mt-24 md:mt-32 mb-12 md:mb-16',
        'h2': 'tt-h2 mt-12 md:mt-16 mb-6 md:mb-8',
        'h3': 'tt-h3 mt-6 md:mt-8 mb-4',
        'h4': 'tt-h4 mt-4 mb-4',
        'h5': '',
        'h6': '',
    }
}) } ) );
viewRegistry.add( 'Html', () => {
    const html = new Html({
        styles: {
            'p': 'text-style -para',
            'b': 'text-style -b',
            'i': 'text-style -i',
            'a': 'text-style -a',
            'ul': 'text-style -list',
            'ol': 'text-style -list',
        }
    })
    return new HtmlView({ data: html});
});

viewRegistry.add("BannerImage", () => new BannerImage());
viewRegistry.add("Image", () => new BaseImageView());
// viewRegistry.add( Image, () => new View({template: '<img view="Image" data=[[this.data]]></img>'}) );
viewRegistry.add( Image, () => new ImageView() );
viewRegistry.add( Carousel, () => new CarouselView() );
viewRegistry.add( MaterialList, () => new MaterialListView() );
viewRegistry.add( DecoratedIframely, () => new DecoratedIframelyView() );
viewRegistry.add( Paragraph, () => new ParagraphView() );
viewRegistry.add( RelatedContent, () => new RelatedContentView());
viewRegistry.add( Toggle, () => new ToggleView());
viewRegistry.add( PersonalImpact, () => new PersonalImpactView());
viewRegistry.add( "Modal", () => new ModalView());
viewRegistry.add( Podcast, () => new PodcastView());
viewRegistry.add( RawHtml, () => new RawHtmlView() );



export var modelRegistry = new ModelRegistry();
